module.exports = __webpack_public_path__ + "img/2. 7 HAIR BUNDLES, TEST STRANDS.jpg";